import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  // Public routes that don't require auth — let Angular router handle them
  const publicPrefixes = ['/confirm', '/privacy', '/terms', '/auth'];
  if (publicPrefixes.some(p => state.url.startsWith(p))) return true;

  if (auth.isLoggedIn()) return true;
  router.navigate(['/auth/login']);
  return false;
};

export const roleGuard = (...roles: string[]): CanActivateFn => () => {
  const auth   = inject(AuthService);
  const router = inject(Router);
  if (auth.hasRole(...roles)) return true;
  router.navigate(['/appointments']);
  return false;
};
